import { AudioSource } from 'cc';

declare module 'cc' {
    // eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-shadow
    interface AudioSource {
        _volumeRate: number;
        volumeRate: number;
        _fadeInStartTime: number;
        fadeInStartTime: number;
        type: AudioSourceType;
    }

    namespace AudioSource {
        enum AudioSourceType {
            Music = 0,
            Effect = 1,
            Voice = 2,
        }
    }
}

enum AudioSourceType {
    Music,
    Effect,
    Voice,
}

AudioSource.AudioSourceType = AudioSourceType;

Object.defineProperty(AudioSource.prototype, 'volumeRate', {
    configurable: true,
    get: function get(this: AudioSource) {
        return this._volumeRate ?? 1;
    },
    set: function set(this: AudioSource, value: number) {
        this._volumeRate = value;
    },
});

Object.defineProperty(AudioSource.prototype, 'fadeInStartTime', {
    configurable: true,
    get: function get(this: AudioSource) {
        return this._fadeInStartTime ?? 0;
    },
    set: function set(this: AudioSource, value: number) {
        this._fadeInStartTime = value;
    },
});
